import React from 'react'
import { useContext } from '../Context'
import map from 'lodash/map'
import filter from 'lodash/filter'
import { AssetTypeEnum } from '@ztechapps/common.contract'
import { Image } from '@ztechapps/webui.util'

export const AssetImages = () => {
  const { document } = useContext()
  const images = filter(document?.assets, { type: AssetTypeEnum.image })
  const imagesUrls = map(images, (e) => ({
    url: e.largeUrl || e.mediumUrl || e.url,
    title: e.title || e.subtitle,
  }))

  return imagesUrls.map((e) => <Image className="my-2 img-fluid " url={e.url} name={e.title} key={e.url} />)
}
